var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropboxSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 31,
    viewBox: "0 0 36 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.81375 0.236328L0.00488281 5.8873L8.81375 11.4552L17.6226 5.8873L8.81375 0.236328ZM26.4315 0.236328L17.6226 5.8873L26.4315 11.4552L35.2403 5.8873L26.4315 0.236328ZM0.00488281 17.1061L8.81375 22.7571L17.6226 17.1061L8.81375 11.4552L0.00488281 17.1061ZM26.4315 11.4552L17.6226 17.1061L26.4315 22.7571L35.2403 17.1061L26.4315 11.4552ZM8.81375 24.5854L17.6226 30.2363L26.4315 24.5854L17.6226 19.0175L8.81375 24.5854Z",
    fill: "#0062FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropboxSvg);
export default __webpack_public_path__ + "static/media/DropboxSvg.a6f6c0cf56f3bd582b62561104d39f93.svg";
export { ForwardRef as ReactComponent };